import {
  deleteOrUpdateTamaño,
  successDeleteFullProducto,
  successGetProducts,
  successProdCreated,
  successNewImage,
  clearError,
  startAction,
  addCarrito,
} from "context/userSlice";
import { axiosPOSTLogin, axiosPRELogin } from "./axios";
import { errorHandler } from "./errorHandler";
import {
  hideOrShowEditPhotoOverlay,
  showOrCloseNotification,
} from "context/generalSlice";
import { BACKEND_ENDPOINTS } from "Theconstants";
import { carritoController } from "utils/carritoControllers";
import {
  filterIfNoStockIsActive,
  processSearchParams,
} from "utils/randomFunctions";
import { AppDispatch, RootState } from "context/store";
import { NotifyBuyerOutOfStockInputs } from "pages/SingleProdPage/auxiliaries/Right";

type ProductosArray = { productos: IProducto[] };
type PaginatedData = {
  total: number;
  totalPaginatedPages: number;
} & ProductosArray;

export type BulkEditCboxState = {
  _id: string;
  checked: boolean;
  esp: {
    _idTamaño: string;
    checked: boolean;
  }[];
}[];

export const productosAPI = {
  getAllProds: async function (
    dispatch: AppDispatch,
    filters: URLSearchParams
  ) {
    try {
      //uso axios postlogins xq si es admin mando incluso prods sin stock (si no es admin mando prods con stock nada mas, salvo q haya hecho una busqueda el user)
      const { data } = await axiosPOSTLogin.get<PaginatedData>(
        `${BACKEND_ENDPOINTS.PRODUCTOS}/?${processSearchParams(filters)}`
      );

      dispatch(
        successGetProducts({
          ...data,
          productos: filterIfNoStockIsActive(data.productos, filters),
        })
      );
    } catch (error) {
      //error handler
      errorHandler(error, dispatch, "GET ALL PRODUCTS");
    }
  },

  getDestacadoSection: async function () {
    //uso axios postlogins xq si es admin mando incluso prods sin stock (si no es admin mando prods con stock nada mas, salvo q haya hecho una busqueda el user)
    return axiosPOSTLogin.get<ProductosArray>(
      `${BACKEND_ENDPOINTS.PRODUCTOS_DESTACADOS}/?destacado=true`
    );
  },

  getFullProdForExcel: async function (filters: URLSearchParams) {
    return axiosPOSTLogin.get<ProductosArray>(
      `${BACKEND_ENDPOINTS.PRODUCTOS_EXCEL}/?${processSearchParams(filters)}`
    );
  },

  //USO ESTE CUANDO EL USER O EL ADMIN ESCRIBEN EN LA SEARCH BAR
  getProdsToShowSuggestions: async function (input: IProducto["nombre"]) {
    try {
      //NO HAY GENERAL STATE ACA, lo hacemos x component
      const { data } = await axiosPRELogin.get<PaginatedData>(
        `productos/?search=${input}`
      );

      /* como le agregué pagination, ahora devuelvo data.productos, antes era solo data */
      return data.productos;
    } catch (error) {
      //NO error handler
      console.log(error, "GET ALL PRODUCTS TO SHOW SUGGESTIONS");
      return Promise.reject();
    }
  },

  //TODO: refactor to avoid sending setProd
  getSingleProd: async function (
    dispatch: AppDispatch,
    _id: IProducto["_id"] | undefined,
    setProducto: React.Dispatch<React.SetStateAction<IProducto>>
  ) {
    dispatch(startAction());

    try {
      const { data } = await axiosPRELogin.get<IProducto>(`/productos/${_id}`);
      /*  dispatch(successGetSingleProduct(data)); */
      dispatch(clearError());
      setProducto(data);
    } catch (error) {
      //error handler
      errorHandler(error, dispatch, "GET SINGLE PRODUCT");
    }
  },

  /**
   * Checks if there has been any changes in the BE on any of the products in the carrito. If that is the case, it removes it from the carrito and notifies the user.
   *
   * @param {AppDispatch} dispatch redux dispatcher
   * @param {RootState["user"]["carrito"]} carrito The carrito
   * @returns Company
   */
  checkCartOnRefresh: async function (
    dispatch: AppDispatch,
    carrito: RootState["user"]["carrito"]
  ) {
    const arrayOfIds = carrito.map((i) => i._id);

    try {
      const { data } = await axiosPRELogin.post<IProducto[]>(
        BACKEND_ENDPOINTS.CHECKCART,
        {
          arrayOfIds,
        }
      );

      const updatedCarrito: RootState["user"]["carrito"] = [];
      let textNotification = "";
      carrito.forEach((i) => {
        const itemFromBackend = data.find((prod) => prod._id === i._id);
        const sizeChosen = itemFromBackend?.esp.find(
          (singleSize) => singleSize._id === i._idTamaño
        );

        if (!itemFromBackend || !sizeChosen) {
          textNotification += `Ha ocurrido un error al actualizar el carrito. Hemos removido el producto ${i.nombre} de ${i._idTamaño}ml de tu carrito. `;
          return;
        }
        //si no hay stock en el backend, directamente no pusheamos nada al updatedCarritoArray
        const { tamaño, stock, descuento, promocion } = sizeChosen;
        const { nombre } = itemFromBackend;
        if (!stock) {
          textNotification += `Hemos removido el producto ${nombre} de ${tamaño}ml de tu carrito, pues ya no hay más stock. `;
          return;
        }
        //CHECK STOCK
        let { qty } = i;

        if (qty > stock) {
          qty = stock;
          textNotification += `Hemos actualizado el stock del producto ${nombre} de ${tamaño}ml. `;
        }
        //CHECK PRICE
        if (sizeChosen.precio !== i.precio) {
          textNotification += `Hemos actualizado el precio del producto ${nombre} de ${tamaño}ml, lo verás reflejado en tu carrito. `;
        }
        //CHECK PROMO
        if (descuento !== i.descuento || promocion !== i.promocion) {
          textNotification += `Hemos actualizado el descuento/promo del producto ${nombre} de ${tamaño}ml, lo verás reflejado en tu carrito. `;
        }

        //TODO: ver xq typee q devuelve sin qty esta fn, probablemente sea usada en 2 lugares
        const finalItem = carritoController.processMyEspObject(
          itemFromBackend,
          {
            ...sizeChosen,
            //todo: VER estos ts-ignores relativos a qty
            //@ts-ignore
            qty,
          }
        );
        //@ts-ignore
        updatedCarrito.push(finalItem);
      });

      if (textNotification) {
        dispatch(
          showOrCloseNotification({ show: true, message: textNotification })
        );
      }

      dispatch(addCarrito(updatedCarrito));
      return data;
    } catch (error) {
      //error handler
      errorHandler(error, dispatch, "CHECK CART ON REFRESH");
    }
  },

  sendEmailLackOfStock: function (
    objInput: NotifyBuyerOutOfStockInputs,
    prodSizeShowing: Omit<ProdCarrito, "qty">
  ) {
    return axiosPRELogin.post<void>(
      `${BACKEND_ENDPOINTS.PRODUCTOS}/notifywhenstockisback/${prodSizeShowing?._id}`,
      { userInfo: objInput, prodSizeShowing }
    );
  },

  createProd: async function (dispatch: AppDispatch, prod: CreateProductoForm) {
    dispatch(startAction());
    const processedEsp = prod.esp.map((i) =>
      i.espInputs.reduce<Pick<IEspecificacion, "tamaño" | "precio" | "stock">>(
        (finalEspItem, i) => {
          finalEspItem[i.id] = i.value;
          return finalEspItem;
        },
        {} as Pick<IEspecificacion, "tamaño" | "precio" | "stock">
      )
    );
    const dataImg = new FormData();
    const arrayEntries = Object.entries(prod);
    arrayEntries.forEach((i) => {
      if (i[0] === "esp") {
        //creo q esto lo tuve q hacer xq el backend sino no me lo tomaba ver notas
        return dataImg.append(i[0], JSON.stringify(processedEsp));
      }
      dataImg.append(i[0], i[1]);
    });
    try {
      const { data } = await axiosPOSTLogin.post<IProducto>(
        BACKEND_ENDPOINTS.PRODUCTOS,
        dataImg
      );
      dispatch(successProdCreated(data));
      dispatch(
        showOrCloseNotification({
          show: true,
          message: "Se cargó exitosamente.",
        })
      );
    } catch (error) {
      errorHandler(error, dispatch, "POST CREATE_PRODUCT");
    }
  },

  updateImg: async function (
    dispatch: AppDispatch,
    img: CreateProductoForm["img"],
    _id: string,
    setImg: React.Dispatch<React.SetStateAction<CreateProductoForm["img"]>>
  ) {
    dispatch(startAction());
    const dataImg = new FormData();
    dataImg.append("img", img as Blob);
    try {
      const { data } = await axiosPOSTLogin.post<IProducto>(
        `${BACKEND_ENDPOINTS.PRODUCTOS}/newimage/${_id}`,
        dataImg
      );
      setImg(null);
      dispatch(successNewImage(data));
      dispatch(hideOrShowEditPhotoOverlay({ show: false }));
      dispatch(
        showOrCloseNotification({
          show: true,
          message: "Se cargó exitosamente la foto.",
        })
      );
    } catch (error) {
      errorHandler(error, dispatch, "POST NEW IMAGE");
    }
  },

  deleteFullProd: async function (
    dispatch: AppDispatch,
    _id: IProducto["_id"]
  ) {
    dispatch(startAction());
    try {
      await axiosPOSTLogin.delete(`${BACKEND_ENDPOINTS.PRODUCTOS}/${_id}`);
      dispatch(successDeleteFullProducto(_id));
    } catch (error) {
      errorHandler(error, dispatch, "DELETE FULL PRODUCTO, NO SOLO TAMAÑOS");
    }
  },

  deleteTamaño: async function (
    dispatch: AppDispatch,
    _id: IEspecificacion["_id"]
  ) {
    dispatch(startAction());
    try {
      const { data } = await axiosPOSTLogin.delete<IProducto>(
        `${BACKEND_ENDPOINTS.PRODUCTOS}/tamano/${_id}`
      );
      dispatch(deleteOrUpdateTamaño(data));
    } catch (error) {
      errorHandler(error, dispatch, "DELETE TAMAñO INDIVIDUAL");
    }
  },

  updateProd: async function (
    dispatch: AppDispatch,
    prod: Partial<
      { esp: Omit<PotencialTamañoNuevoACrear, "_id">[] } & Pick<
        IProducto,
        | "_id"
        | "nombre"
        | "sexo"
        | "marca"
        | "destacado"
        | "descripcion"
        | "img"
      >
    >,
    _id: IProducto["_id"]
  ) {
    //recibo la _id aparte y no con el prod xq asi resultó cuando agrego tamaño nuevo, ver si conviene fusionarlo previamente
    dispatch(startAction());
    try {
      //ver si mando _id tamaño o prod entero
      const { data } = await axiosPOSTLogin.put<IProducto>(
        `${BACKEND_ENDPOINTS.PRODUCTOS}/${_id}`,
        prod
      );
      //Updatear el state, vuelve el producto individual ya modificado
      dispatch(deleteOrUpdateTamaño(data));
    } catch (error) {
      errorHandler(error, dispatch, "PUT SINGLE_PRODUCT");
    }
  },

  //DONE ts: ✅, double check though
  bulkUpdate: async function (
    dispatch: AppDispatch,
    arrayProd: BulkEditCboxState,
    typeOfBulkEdit: {
      type: string;
      //TODO: a futuro tipear possible strings y ver de refactorizar
      /*      | "destacado"
        | "promo"
        | "stock"; 
        | '+precio' + editType( o sea son 2 tipos)
        | '-precio' + editType ( o sea son 2 tipos)
            */
      value: any; //TODO: dejè comentarios del otro lado de xq any, a futuro tratar de tipear
    }
  ) {
    const { type, value } = typeOfBulkEdit;
    type SingleProdType = { _id: string; espIdArray: string[] };

    function processArrayToSendOnlyIds(arrayProd: BulkEditCboxState) {
      return arrayProd.reduce<SingleProdType[]>((final, item) => {
        let singleProd: SingleProdType = {
          _id: item._id,
          espIdArray: [],
        };

        // if cbox is checked we push it to the array
        item.esp.forEach((espSingle) => {
          if (espSingle.checked) {
            singleProd.espIdArray.push(espSingle._idTamaño);
          }
        });

        if (singleProd.espIdArray.length > 0) {
          final.push(singleProd);
        }

        return final;
      }, []);
    }

    const depurado = processArrayToSendOnlyIds(arrayProd);

    try {
      if (!depurado.length)
        throw Error("No seleccionaste productos para editar.");

      dispatch(startAction());

      const { data } = await axiosPOSTLogin.put<IProducto[]>(
        `${BACKEND_ENDPOINTS.PRODUCTOS_GROUP_EDIT}/?type=${type}&value=${value}`,
        depurado
      );

      //TODO: a futuro esta fn es muy amplia, usa bulk updates y singleProd updates + delete, y tiene mucha lògica en el store, no soy suuuper fan
      dispatch(deleteOrUpdateTamaño(data));
    } catch (error) {
      errorHandler(error, dispatch, "PUT SINGLE_PRODUCT");
      return Promise.reject();
    }
  },
};
